/**
 * @generated SignedSource<<071ee7dc413e5421da3fc071d4c17db1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EditDigestJobDialogValidateQuery$variables = Record<PropertyKey, never>;
export type EditDigestJobDialogValidateQuery$data = {
  readonly validateDigestIntegrations: {
    readonly defaultContent: ReadonlyArray<{
      readonly section: string;
      readonly text: string;
    }>;
    readonly hasGithub: boolean;
    readonly hasMonitoring: boolean;
    readonly isValid: boolean;
    readonly missingIntegrations: ReadonlyArray<string>;
  };
};
export type EditDigestJobDialogValidateQuery = {
  response: EditDigestJobDialogValidateQuery$data;
  variables: EditDigestJobDialogValidateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DigestIntegrationValidationResult",
    "kind": "LinkedField",
    "name": "validateDigestIntegrations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMonitoring",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasGithub",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "missingIntegrations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DigestDefaultSection",
        "kind": "LinkedField",
        "name": "defaultContent",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "section",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDigestJobDialogValidateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EditDigestJobDialogValidateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "eefaed7d5472d8e8552873624d59f305",
    "id": null,
    "metadata": {},
    "name": "EditDigestJobDialogValidateQuery",
    "operationKind": "query",
    "text": "query EditDigestJobDialogValidateQuery {\n  validateDigestIntegrations {\n    isValid\n    hasMonitoring\n    hasGithub\n    missingIntegrations\n    defaultContent {\n      section\n      text\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37ea9845948e31b001e024ee8593b3e9";

export default node;
